export const newRelicLog = (body: any) =>
  fetch('https://log-api.eu.newrelic.com/log/v1', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      'X-License-Key': `${process.env['NEW_RELIC_API_KEY']}`,
    },
  });
export default newRelicLog;
